import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function VolumeOnIcon(props, ref) {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    ...props,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3 10a2 2 0 0 1 2-2h2l3.293-3.293c.63-.63 1.707-.184 1.707.707v13.172c0 .89-1.077 1.337-1.707.707L7 16H5a2 2 0 0 1-2-2zm4.828 4L10 16.172V7.828L7.828 10H5v4zm6.294-5.536a1 1 0 0 1 1.414 0A5 5 0 0 1 17 12c0 1.38-.56 2.632-1.464 3.535a1 1 0 1 1-1.415-1.414 3 3 0 0 0 .88-2.121c0-.829-.335-1.578-.88-2.122a1 1 0 0 1 0-1.414"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.364 5.636A1 1 0 1 0 16.95 7.05 6.98 6.98 0 0 1 19 12a6.98 6.98 0 0 1-2.05 4.95 1 1 0 0 0 1.414 1.414A8.98 8.98 0 0 0 21 12a8.98 8.98 0 0 0-2.636-6.364"
    })]
  });
}
;
VolumeOnIcon.displayName = "VolumeOnIcon";
export default forwardRef(VolumeOnIcon);